import ContentCollection from './ContentCollection'
import ContentDetails from './ContentDetails'

export default [ContentCollection, ContentDetails]
